import { get } from 'lodash';
import React, { useState, useEffect, useRef } from 'react';
import Spinner from '../Spinner';
import style from './style.module.css';

const BrokenImage = ({ className, icon = "fa-image", sizer }) => {
    return (
        <>
            {
                sizer === true && (
                    <div className={style.sizer}></div>
                )
            }
            <div className={style.bsz}>
                <div className={`${style.bgImage}${className ? " " + className : ""}`}>
                    <div className={style.fa}>
                        <i className={`fa-solid ${icon}`}></i>
                    </div>
                </div>
            </div>
        </>
    )
}

const NormalImage = ({ src, className, alt }) => {
    return (
        <div className={style.bsz}>
            <div className={`${style.bgImage}${className ? " " + className : ""}`} style={{ backgroundImage: `url("${encodeURI(src)}")` }}>
                <img src={src} alt={alt} />
            </div>
        </div>
    )
}

const LazyImage = ({ src, className, alt, sizer }) => {
    const [loaded, setLoaded] = useState(0);
    const [dimesion, setDimension] = useState([0, 0]);
    const [isIntersecting, setIntersecting] = useState(false)
    const ref = useRef();
    let img = new Image();
    let observer;

    try {
        observer = new IntersectionObserver(
            ([entry]) => setIntersecting(entry.isIntersecting)
        )
    } catch (err) {
        console.error("IntersectionObserver not available:", err)
    }

    const loadImage = () => {
        img.src = src;
        if (img.complete || img.readystate === 4) {
            setLoaded(1);
            setDimension([img.width, img.height]);
        }
        else {
            img.onload = () => {
                setLoaded(1);
                setDimension([img.width, img.height]);
            }
            img.onerror = () => {
                setLoaded(2);
            }
        }
    }

    useEffect(() => {
        if (loaded === 0) {
            if (isIntersecting) {
                try {
                    if (observer){
                    // Remove the observer once intersected or error
                    observer.disconnect();
                    } 
                } catch (err) {
                    console.error("Observer disconnect failed:", err);
                }
                loadImage();
            }
            else {
                try {
                    if (observer && ref.current) {
                        observer.observe(ref.current);
                    }
                } catch (err) {
                    console.error("Observer observe failed:", err);
                }
            }
        }

        return () => {
            try {
                if (observer){
                // Remove the observer as soon as the component is unmounted
                observer.disconnect()
                } 
            } catch (err) {
                console.error("Observer disconnect failed:", err)
            }
        }
    })

    return (
        <>
            {
                sizer === true && (
                    <div className={style.sizer} style={{ paddingTop: `${dimesion[0] > 0 && dimesion[1] > 0 ? dimesion[1] * 100 / dimesion[0] : 50}%` }}></div>
                )
            }
            <div className={style.bsz} ref={ref}>
                <div className={`${style.bgImage}${className ? " " + className : ""}${loaded === 0 ? " " + style.loading : ""}`} style={{ backgroundImage: loaded === 1 ? `url("${encodeURI(src)}")` : "none" }}>
                    {
                        loaded === 1 && (
                            <img src={src} alt={alt} />
                        )
                    }
                    {
                        loaded === 0 && (
                            <div className={style.spinner}>
                                <Spinner color="#fff" />
                            </div>
                        )
                    }
                    {
                        loaded === 2 && (
                            <div className={style.fa}>
                                <i className={`fa-regular fa-image-slash`}></i>
                            </div>
                        )
                    }
                </div>
            </div>
        </>
    )
}

const Background = ({ src, cdn = false, className = false, alt = "", size = "uploads", lazy = true, fallback = true, retainAspectRatio = false, svg = false }) => {

    // let image_url =  + size+'/'+ + src;
    let image_url = `${process.env.REACT_APP_IMAGES}/${size}/${get(src, 'id', '')}`

    // SVG Image
    if (svg) {
        return <img src={image_url} alt={alt} />
    }
    //If src is empty then display a broken image
    if (!src) {
        if (fallback === true) {
            //Show a broken image for fallback if set to true
            return (
                <BrokenImage sizer={retainAspectRatio} />
            )
        }
        return null;
    }

    //Construct image url using CDN

    if (cdn === false) {
        image_url = get(src, 'id', '');
    }
    if (cdn === "static") {
        image_url = src;
    }

    //If lazy load is disabled, then display the image directly
    if (lazy === false && retainAspectRatio === false) {
        return (
            <NormalImage src={image_url} className={className} alt={alt} />
        )
    }

    //Lazy load the image
    return (
        <LazyImage src={image_url} className={className} alt={alt} sizer={retainAspectRatio} />
    )
}

export default Background;